import _class_call_check from "@swc/helpers/src/_class_call_check.mjs";
import _inherits from "@swc/helpers/src/_inherits.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _create_super from "@swc/helpers/src/_create_super.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import cx from "classnames";
import React from "react";
import { FocusOn } from "react-focus-on";
import CSSTransition from "react-transition-group/CSSTransition";
import Portal from "../portal/portal.component";
import Card from "../card";
import * as baseStyles from "./modal.module.css";
var TIMEOUT = 250;
var Modal = /*#__PURE__*/ function(_Component) {
    "use strict";
    _inherits(Modal, _Component);
    var _super = _create_super(Modal);
    function Modal(props) {
        _class_call_check(this, Modal);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            mounted: false
        };
        _this.close = function(event) {
            if (_this.isInTheDOM()) {
                if (_this.props.onClose) {
                    _this.props.onClose(event);
                }
                _this.setState({
                    mounted: false
                });
            }
        };
        _this.backdropId = "backdrop";
        _this.onKeyDown = function(event) {
            if (event.key === "Escape") {
                _this.close(event);
            }
        };
        _this.onMouseDown = function(event) {
            if (event.target.id === _this.backdropId) {
                _this.close(event);
            }
        };
        _this.elementRef = /*#__PURE__*/ React.createRef();
        return _this;
    }
    var _proto = Modal.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.setState({
            mounted: true
        });
        document.addEventListener("keydown", this.onKeyDown, false);
        document.addEventListener("mousedown", this.onMouseDown, false);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        document.removeEventListener("keydown", this.onKeyDown, false);
        document.removeEventListener("mousedown", this.onMouseDown, false);
    };
    _proto.isInTheDOM = function isInTheDOM() {
        return document.contains(this.elementRef.current);
    };
    _proto.render = function render() {
        var _this = this;
        var _props = this.props, children = _props.children, title = _props.title, subtitle = _props.subtitle, cardStyles = _props.cardStyles, classNames = _props.classNames, closeText = _props.closeText, _closeable = _props.closeable, closeable = _closeable === void 0 ? true : _closeable, closeIcon = _props.closeIcon, testId = _props.testId;
        var classes = _object_spread({}, baseStyles, classNames);
        var backdropClassNames = {
            enter: classes.backdropEnter,
            enterActive: classes.backdropEnterActive,
            exit: classes.backdropExit,
            exitActive: classes.backdropExitActive
        };
        var modalClassNames = {
            enter: classes.modalEnter,
            enterActive: classes.modalEnterActive,
            exit: classes.modalExit,
            exitActive: classes.modalExitActive
        };
        var isDesktop = "object" !== "undefined" && window.matchMedia("(min-width: 1024px)").matches;
        return /*#__PURE__*/ _jsx(Portal, {
            children: /*#__PURE__*/ _jsx(CSSTransition, {
                appear: true,
                classNames: backdropClassNames,
                unmountOnExit: true,
                timeout: TIMEOUT,
                in: this.state.mounted,
                children: function(state) {
                    /*#__PURE__*/ return _jsx("div", {
                        id: _this.backdropId,
                        ref: _this.elementRef,
                        role: "presentation",
                        className: cx(classes.backdrop, classes.backdropStyle),
                        children: /*#__PURE__*/ _jsx(CSSTransition, {
                            appear: true,
                            classNames: modalClassNames,
                            unmountOnExit: true,
                            timeout: TIMEOUT,
                            in: state === "entered",
                            children: /*#__PURE__*/ _jsx(FocusOn, {
                                enabled: !isDesktop,
                                children: /*#__PURE__*/ _jsx("div", {
                                    "data-testid": testId,
                                    className: classes.modal,
                                    role: "dialog",
                                    "aria-modal": "true",
                                    children: /*#__PURE__*/ _jsx(Card, _object_spread_props(_object_spread({
                                        title: title,
                                        subtitle: subtitle,
                                        cardStyles: cardStyles,
                                        classNames: {
                                            card: classNames === null || classNames === void 0 ? void 0 : classNames.cardContainer,
                                            body: classNames === null || classNames === void 0 ? void 0 : classNames.cardBody,
                                            title: classNames === null || classNames === void 0 ? void 0 : classNames.cardTitle,
                                            titleContainer: classNames === null || classNames === void 0 ? void 0 : classNames.cardTitleContainer,
                                            closeIcon: classNames === null || classNames === void 0 ? void 0 : classNames.cardCloseIcon
                                        },
                                        closeIcon: closeIcon
                                    }, closeable ? {
                                        onClose: _this.close,
                                        closeText: closeText
                                    } : {}), {
                                        children: children
                                    }))
                                })
                            })
                        })
                    });
                }
            })
        });
    };
    return Modal;
}(React.Component);
export default Modal;
